const CheckIcon = ({ className = "", size = 30, color = "#E2B457" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      className={className}
      viewBox="0 0 30 30" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M23.375 9C22.875 8.5 22.125 8.5 21.625 9L12.25 18.375L8.375 14.5C7.875 14 7.125 14 6.625 14.5C6.125 15 6.125 15.75 6.625 16.25L11.375 21C11.625 21.25 11.875 21.375 12.25 21.375C12.625 21.375 12.875 21.25 13.125 21L23.375 10.75C23.875 10.25 23.875 9.5 23.375 9Z" 
        fill={color}
      />
    </svg>
  );
};

export default CheckIcon;